var map = {
	"./0.png": "./src/assets/images/index/map/jt/0.png",
	"./1.png": "./src/assets/images/index/map/jt/1.png",
	"./10.png": "./src/assets/images/index/map/jt/10.png",
	"./11.png": "./src/assets/images/index/map/jt/11.png",
	"./12.png": "./src/assets/images/index/map/jt/12.png",
	"./13.png": "./src/assets/images/index/map/jt/13.png",
	"./14.png": "./src/assets/images/index/map/jt/14.png",
	"./15.png": "./src/assets/images/index/map/jt/15.png",
	"./16.png": "./src/assets/images/index/map/jt/16.png",
	"./17.png": "./src/assets/images/index/map/jt/17.png",
	"./18.png": "./src/assets/images/index/map/jt/18.png",
	"./19.png": "./src/assets/images/index/map/jt/19.png",
	"./2.png": "./src/assets/images/index/map/jt/2.png",
	"./20.png": "./src/assets/images/index/map/jt/20.png",
	"./21.png": "./src/assets/images/index/map/jt/21.png",
	"./22.png": "./src/assets/images/index/map/jt/22.png",
	"./23.png": "./src/assets/images/index/map/jt/23.png",
	"./24.png": "./src/assets/images/index/map/jt/24.png",
	"./3.png": "./src/assets/images/index/map/jt/3.png",
	"./4.png": "./src/assets/images/index/map/jt/4.png",
	"./5.png": "./src/assets/images/index/map/jt/5.png",
	"./6.png": "./src/assets/images/index/map/jt/6.png",
	"./7.png": "./src/assets/images/index/map/jt/7.png",
	"./8.png": "./src/assets/images/index/map/jt/8.png",
	"./9.png": "./src/assets/images/index/map/jt/9.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/index/map/jt sync recursive ^\\.\\/.*\\.png$";